export default {
    'en': {
        first_steps_title: 'First steps / what to do?',
        first_steps_content: 'In order to use the ConsentFox and become GDPR and/or CCPA compliant with your website you will need to follow several steps. Here is the high level overview on what you need to do:\n' +
         '  \n' +
         'Create a domain\n' +
         'Once you registered @ ConsentFox we automatically assigned you As a next step you need to create a CMP. A CMP is basically the collection of all the settings that you want to do (general settings, legal settings, designs, texts and so on). For each CMP you create you will later get a code that you can intergate into your website in order to show the consent message. See the help section on how to create a CMP.\n' +
         'Manage vendors and cookies\n' +
         'Once the CMP is created, our crawler will start a first crawl. Once it is finished you can assign the vendors and cookies to purposes. See the help section on how to configure vendors and cookies.\n' +
         'Create your own design & texts\n' +
         '(optional) In order to further customize the appearance of your CMP you can create an own design and change texts. See our help section on how to configure the design & texts.\n' +
         'Integrate the CMP-Code into your website\n' +
         'As the next step you will need to integrate the CMP-Code into your website. This can be integrated directly into the website code or indirect via a TagManager or Plugin. See the help section on how to integrate the code.\n' +
         'Block third party codes & cookies\n' +
         'As a last step you will need to align third party codes in your website in order to allow our system to block these codes in case no consent / an opt-out is given for this visitor. See the help section on how to block third party codes and cookies on your website.\n' +
         'Update your privacy policy\n' +
         'It is recommended to update your privacy policy and mention that you work with consentmanager as your CMP. See the help section on updating your privacy policy.\n' +
         'CCPA compliance: Insert "Do not sell my personal information" Link\n' +
         'For CCPA compliance you should insert a link with the text "Do not sell my personal information" into your website. See the help section on Do not sell my personal information links.',
    },
    'de': {
    
    },
    'fr': {

    },
    'nl': {

    },
    'el': {

    }

}